import { checkTask } from './useMassActions.api'
import { TASK_STATUS_INTERVAL } from './useMassActions.constants'

export function checkTaskStatus(params, handler) {
  const { checkTaskFetch = checkTask, ...restParams } = params

  checkTaskFetch(params.task).then(({ data }) => {
    if (data.completed || data.ready) {
      handler(data, restParams)
    } else {
      setTimeout(() => checkTaskStatus(params, handler), TASK_STATUS_INTERVAL)
    }
  })
}
